<template>
    <div>
        <div class="subbar" v-if="instance">
            <div class="dF aC mb-0">
                <div>
                    <div>
                        <a-breadcrumb>
                            <a-breadcrumb-item>{{
                                instance.name
                            }}</a-breadcrumb-item>
                            <a-breadcrumb-item>{{
                                selectedAppInitial
                            }}</a-breadcrumb-item>
                            <a-breadcrumb-item v-if="crumbs != ''">{{
                                crumbs
                            }}</a-breadcrumb-item>
                        </a-breadcrumb>
                    </div>
                </div>
                <div class="dF aC ml-auto d-none d-sm-flex">
                    <a-button
                        @click="$store.commit('SHOW_STACK_SETTINGS')"
						type="primary"
						ghost
						class="mr-3"
						size="large"
                    >
                        <i class="fe fe-edit btn-addon-icon mr-2" /> STACK SETTINGS
                    </a-button>
					<a-button
                        @click="$store.commit('SHOW_ADD_FLOOR')"
                        type="primary"
						size="large"
                    >
                        <i class="fe fe-edit btn-addon-icon mr-2" /> FLOOR SETTINGS
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        selectedAppInitial() {
            return this.$store.state.theApp?.media?.initial || "CGC"
        },
        instance() {
            return this.$store.state.instance;
        },
        crumbs() {
            return this.$store.state.condogrid.crumbs;
        },
    },
};
</script>
